/* eslint-disable import/no-unresolved */
import { createGlobalStyle } from 'styled-components';
import designTokens from '@resultadosdigitais/tangram-design-tokens/tangram-design-tokens.css';
const DesignTokens = createGlobalStyle(["", ""], designTokens);
export default DesignTokens;